(() => {
    const storageKey = 'cmra_recent';
    let checkedProductsData = JSON.parse(localStorage.getItem(`[${storageKey}]`) || '[]');
    const elts = document.querySelectorAll('.js-cm-checked');

    /*********/

    class Product {
        constructor(handle) {
            this.handle = handle;

            this.data = {
                id: null,
                title: null,
                price: null,
                priceVaries: false,
                priceMin: null,
                priceMax: null,
                compareAtPrice: null,
                img: null,
                available: false,
                sale: false
            }
        }

        static formatPrice(price) {
            return new Intl.NumberFormat('ja-JP').format((price / 100.0).toFixed());
        }

        init() {
            return this.getProductData().then((data) => {
                if (!data || !data.handle) {
                    return null
                } else {
                    this.setProductData(data);
                    return this;
                }
            });
        }

        setProductData(data) {
            this.data.id = data.id;
            this.data.title = data.title;
            this.data.price = Product.formatPrice(data.price);
            this.data.priceVaries = data.price_varies;
            this.data.priceMin = Product.formatPrice(data.price_min);
            this.data.compareAtPrice = data.compare_at_price ? Product.formatPrice(data.compare_at_price) : null;
            this.data.img = data.images[0] ? data.images[0] : data.featured_image;
            this.data.available = data.available;
            this.data.sale = data.compare_at_price ? data.compare_at_price > data.price : false;
            this.data.createdAt = data.created_at;
            this.data.tags = data.tags;
        }

        getProductData() {
            return fetch(`${window.Shopify.routes.root}products/${this.handle}.js`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`${response.status} ${response.statusText}`);
                    }
                    return response.json();

                }).catch((error) => { });
        }
    }

    class ProductSlider {
        constructor(container, parent = null) {
            this.variesSymbol = window.Shopify.locale === 'ja' ? '～' : ' - ';
            this.removePrice = window.Shopify.currency.active !== 'JPY';
            /////
            this.sliderInit = false;
            this.displayLimit = Number(container.dataset.checkedLimit) || 10;
            this.currentPage = container.dataset.checkedPage;
            this.currentProduct = this.currentPage === 'product' ? (container.dataset.checkedProduct || null) : null;
            /////
            this.container = container;
            this.parent = parent;
            this.slider = container.querySelector('.js-cm-checked-slider');
            this.sliderList = this.slider ? this.slider.querySelector('.splide__list') : null;
            this.slideTemplate = this.slider ? this.slider.querySelector('.js-cm-slide-template') : null;
        }

        init() {
            if (!this.slider) return;

            if (!(this.sliderList && this.slideTemplate)) return;

            if (this.parent) {
                this.parent.style.display = 'none';
            }

            if (this.currentProduct) {
                addProduct(this.currentProduct);
                updateStorage();
            }

            if (checkedProductsData.length >= 1) {
                // TODO: outside of loop
                getProducts().then((list) => {
                    updateProducts(list, this.displayLimit);
                    updateStorage();
                    this.renderSlider(list.filter((productItem) => productItem && productItem.handle != this.currentProduct));
                });
            }
        }

        renderSlider(products) {
            products.forEach((productItem, i) => {
                const slideClone = this.slideTemplate.content.cloneNode(true).firstElementChild;
                this.renderPrice(slideClone, productItem.data);
                this.renderInfo(slideClone, productItem.handle, productItem.data.title, productItem.data.id);
                this.renderImage(slideClone, productItem.data.img);
                //this.renderBadges(slideClone, productItem.data);

                this.sliderList.append(slideClone);
            });

            if (document.readyState === 'complete') {
                this.initSlider(products);
            } else {
                window.addEventListener('DOMContentLoaded', (e) => {
                    this.initSlider(products);
                });
            }
        }

        renderPrice(slide, data) {
            const priceContainer = slide.querySelector('.card-information > .price');

            if (!priceContainer) return;

            if (this.removePrice) {
                priceContainer.remove();
                return;
            }

            if (data.available) {
                priceContainer.classList.remove('price--sold-out');
            }

            if (data.priceVaries) {
                priceContainer.querySelector('.price__regular .price-item--regular').innerHTML = `¥${data.priceMin}<span class="price-item-from">から</span><span class="price-item-tax">税込</span>`;
            } else {
                priceContainer.querySelector('.price__regular .price-item--regular').innerHTML = ` ¥${data.price}<span class="price-item-tax">税込</span>`;
            }
        }

        renderInfo(slide, handle, title, id) {
            const link = slide.querySelector('.card__heading a');
            const setId = null;
            link.href = `${window.Shopify.routes.root}products/${handle}`
            link.removeAttribute('aria-disabled');
            link.textContent = title;

            if (setId) {
                link.id = `${setId}-${id}`;
            }
        }

        // renderBadges(slide, data) {
        //     const badgeContainer = slide.querySelector('.cm-product-badges');
        //     if (!badgeContainer) return;

        //     let badgeContent = '';

        //     if (!data.available) {
        //         badgeContent += `<li><span class="badge">売り切れ</span></li>`;
        //     } else if (data.sale) {
        //         badgeContent += `<li><span class="badge badge--sale">セール</span></li>`;
        //     }

        //     if (data.tags.includes('予約商品')) {
        //         badgeContent += `<li><span class="badge badge--preorder">予約商品</span></li>`
        //     } else if (data.tags.includes('季節限定')) {
        //         badgeContent += `<li><span class="badge badge--seasonal">季節限定</span></li>`
        //     }

        //     badgeContainer.innerHTML = badgeContent;
        // }

        renderImage(slide, image) {
            const placeholder = slide.querySelector('.placeholder-svg');

            if (!placeholder) return;

            if (!image) {
                placeholder.remove();
                return;
            }

            const img = document.createElement('img');
            img.src = image;
            img.width = '240';
            img.height = '288';
            img.loading = 'lazy';
            img.alt = '';

            slide.querySelector('.card').classList.add('card--media');

            placeholder.replaceWith(img);
        }

        initSlider(products = []) {
            if (!Splide || this.sliderInit) return;
            this.sliderInit = true;
            
            const text = {
                prev: `{{ 'cm.slider.prev' | t }}`,
                next: `{{ 'cm.slider.next' | t }}`,
                first: `{{ 'cm.slider.first' | t }}`,
                last: `{{ 'cm.slider.last' | t }}`,
                slideX: `{{ 'cm.slider.page' | t }}`,
                select: `{{ 'cm.slider.select' | t }}`
            };

            const splide = new Splide(this.slider, {
                fixedWidth: 'min(18.75vw, 270px)',
                perMove: 1,
                arrows: true,
                pagination: true,
                gap: '36px',
                padding: 'max(36px, calc((100vw - 1200px) / 2))',
                breakpoints: {
                    [1272]: {
                        padding: 'max(36px, calc((100vw - 1128px) / 2))',
                    },
                    [1200]: {
                        fixedWidth: 'min(25%, 270px)'
                    },
                    [750]: {
                        padding: 'max(16px, calc((100vw - 1200px) / 2))',
                        gap: '16px',
                        fixedWidth: 'max(37%, 160px)'
                    }
                },
                i18n: {
                    prev: text.prev,
                    next: text.next,
                    slideX: text.slideX,
                    first: text.first,
                    last: text.last,
                    select: text.select
                },
            });

            splide.mount();

            if (this.parent && products.length) {
                this.parent.style.display = 'block';                
            }
        }
    }

    /*********/

    async function getProducts() {
        const productList = await checkedProductsData.map(async (handle, i) => {
            const productItem = await new Product(handle).init();
            return productItem;
        });

        return Promise.all(productList);
    }

    function addProduct(currentProduct) {
        // ローカルストレージに同じ商品が存在する場合、削除
        const duplicateIndex = checkedProductsData.findIndex((handle) => handle === currentProduct);
        if (duplicateIndex > -1) {
            checkedProductsData.splice(duplicateIndex, 1);
        }

        // 現在表示されている商品情報を追加
        checkedProductsData.unshift(currentProduct);
    }

    function updateProducts(list, displayLimit) {
        // 商品が正しく登録されてないと削除
        let newList = list.filter((product, i) => product && product.handle);

        // 指定した個数を超えた場合、削除
        if (newList.length > displayLimit) {
            newList = newList.slice(0, displayLimit);
        }

        checkedProductsData = newList.map((product) => product.handle);
    }

    function updateStorage() {
        // ローカルストレージに格納
        try {
            localStorage.setItem(`[${storageKey}]`, JSON.stringify(checkedProductsData));
        } catch (error) { }
    }

    /*********/

    if (elts.length < 1) return;

    elts.forEach(container => {
        const parentSection = container.closest('.cm-checked-wrapper');
        const slider = new ProductSlider(container, parentSection);
        slider.init();
    });
})();